"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@ori-ui/mui-bundle/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3.751c-4.549 0-8.249 3.7-8.249 8.249S7.452 20.249 12 20.249s8.249-3.7 8.249-8.249S16.548 3.751 12 3.751M4.794 12c0-3.973 3.233-7.206 7.206-7.206 1.8 0 3.447.663 4.711 1.758L6.551 16.711a7.18 7.18 0 0 1-1.757-4.71zM12 19.206c-1.8 0-3.447-.663-4.711-1.758l10.16-10.159a7.18 7.18 0 0 1 1.757 4.71c0 3.973-3.233 7.206-7.206 7.206z"
}), 'Cancel');
